import React, { useContext, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import image from '../../../assets/image/welcome/slide1.svg';
import { projectTypes } from '../../../constans/constans';
import CustomCheckbox from '../../../generic/CustomCheckbox';
import CustomBtn from '../../../generic/CustomBtn';
import { ContextForm } from '../../../utils/projectRegistration';

const ProjectTypeSelect = () => {
  const translate = useIntl();

  const { handleSubmit, register, formState: { isValid } } = useForm({
    mode: 'all',
    defaultValues: {
      projectType: null,
    },
  });
  const { formData, setFormData } = useContext(ContextForm);
  const [radioButtons, setRadioButtons] = useState(projectTypes(translate));

  const onRadioChange = (e) => {
    const value = e.target.value;
    const newRadioButtons = [...radioButtons];
    newRadioButtons.forEach((item) => {
      item.checked = item.value === value;
    });
    setRadioButtons(newRadioButtons);
  };

  const onSubmit = (data) => {
    setFormData({
      ...formData,
      activeProjectStep: formData.activeProjectStep + 1,
      projectType: data.projectType,
    });
  };

  return (
    <div className="project-register__projectTypeSelectWrapper">
      <div className="project-register__projectTypeSelectWidth">
        <ReactSVG src={image} className="welcome__image" />
        <h2 className="project-register__title">
          {translate.formatMessage({ id: 'project-register.launchANewProject' })}
        </h2>
        <FormattedMessage
          id="project-register.projectTypeSelectDescription"
          values={{
            p: (...chunks) => <p className="project-register__subtitle">{chunks}</p>,
            br: <br />,
          }}
        />
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="project-register__marginTop">
        <label className="project-register__checkBoxLabel">
          {translate.formatMessage({ id: 'wizardForm.step1.projectType' })}
        </label>
        {radioButtons.map(({ value, title, description }) => (
          <CustomCheckbox
            type="radio"
            value={value}
            title={translate.formatMessage({ id: title })}
            description={translate.formatMessage({ id: description })}
            register={register({
              required: true,
            })}
            name="projectType"
            key={value}
            onChange={onRadioChange}
          />
        ))}
        <div className="project-register__marginTop">
          <div className="project-register__projectTypeSelectWidth">
            <CustomBtn
              label={translate.formatMessage({ id: 'button-next' })}
              type="submit"
              customClass={isValid ? 'btn__btn-next' : 'btn__btn-prev'}
              disabled={!isValid}
              handleClick={() => {}}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProjectTypeSelect;
